import { useAuthQuery } from 'queries/query';
import { getQueryKeys } from 'queries/query-key';
import { KEY } from './keys';
import { StickerApi } from 'api';

function useGetAll() {
  return useAuthQuery(getQueryKeys([KEY]).lists(), () => StickerApi.getAll(), {
    select: (data) => data.data,
  });
}

export default useGetAll;
